import immutableUpdate from 'immutable-update'

const initialState = {
  test: false
}

const reducers = { 

  UI_TEST: (state, action) => {

    return immutableUpdate(
      state,
      {
        test: action.payload.data
      }
    )
  }
}

const ui = (state = initialState, action) => reducers[action.type] ? 
  reducers[action.type](state, action)
  :
  { ...state }

export default ui 